var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"upload-wrapper"},[_c('Tinymce',{attrs:{"accept":_vm.accept,"form":_vm.form,"model":_vm.models}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }